import React, { useState, useEffect } from "react";
import CircleIcon from "@mui/icons-material/Circle";
import IconButton from "@mui/material/IconButton";

const MCQOption = (props) => {
  return (
    <IconButton edge="end" aria-label="select" onClick={props.press}>
      <CircleIcon
        fontSize="small"
        value="a"
        name="radio-buttons"
        sx={{
          color: props.selected ? "#DB8829" : "#FFFFFF",
          border: props.selected ? 0 : 2,
          borderColor: props.selected ? "#DB8829" : "#C9C9C9",
          borderRadius: "50%",
          "@media (min-width: 1636px)": {
            fontSize: "1.4rem",
          },
        }}
      />
    </IconButton>
  );
};

export default MCQOption;
